import { useRecoilValueLoadable } from "recoil";
import { evidenceAtom } from "@state/State";
import { IEvidence, ProgramData } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";
import { useProgramCycles } from "./useProgramCycles";

export const useProgramCycleEvidence = (program: ProgramData | null) => {
  const allEvidence = useRecoilValueLoadable<IEvidence[] | null>(evidenceAtom);
  const { currentProgramCycle } = useProgramCycles(program?.ID ?? "");

  let evidenceForProgram: IEvidence[] = [];

  if (program) {
    evidenceForProgram = ProgramUtils.getEvidenceForProgramName(allEvidence.contents, program?.Name);
  }

  let evidenceForCycle: IEvidence[] | undefined;

  if (currentProgramCycle) {
    evidenceForCycle = evidenceForProgram.filter(
      (item) => item.evidenceJSON?.programInfo?.programCycle === currentProgramCycle
    );
  }

  return evidenceForCycle;
};
